import React from 'react';
import Icon from '../../../components/AppIcon';

const NextStepsGuide = () => {
  const steps = [
    {
      icon: "FolderOpen",
      title: "Extract ZIP File",
      description: "Unzip the downloaded file to your preferred location"
    },
    {
      icon: "Terminal",
      title: "Install Dependencies",
      description: "Run npm install in both frontend and backend directories"
    },
    {
      icon: "Database",
      title: "Setup Database",
      description: "Execute the provided SQL migration files in your database"
    },
    {
      icon: "Settings",
      title: "Configure Environment",
      description: "Update .env files with your API keys and database credentials"
    },
    {
      icon: "Play",
      title: "Start Development",
      description: "Run npm run dev to start your local development server"
    }
  ];

  const recommendedTools = [
    { name: "VS Code", icon: "Code2", url: "#" },
    { name: "Postman", icon: "Send", url: "#" },
    { name: "Docker", icon: "Box", url: "#" },
    { name: "Git", icon: "GitBranch", url: "#" }
  ];

  return (
    <div className="bg-card rounded-lg p-4 md:p-6 border border-border">
      <h3 className="text-base md:text-lg font-semibold mb-4 flex items-center gap-2">
        <Icon name="Lightbulb" size={20} className="text-accent" />
        Next Steps
      </h3>
      <div className="space-y-3 md:space-y-4 mb-6">
        {steps?.map((step, index) => (
          <div key={index} className="flex gap-3 md:gap-4">
            <div className="flex-shrink-0 w-8 h-8 md:w-10 md:h-10 rounded-full bg-primary flex items-center justify-center text-primary-foreground font-semibold text-sm md:text-base">
              {index + 1}
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-1">
                <Icon name={step?.icon} size={16} className="text-primary flex-shrink-0" />
                <h4 className="text-sm md:text-base font-semibold">{step?.title}</h4>
              </div>
              <p className="text-xs md:text-sm text-muted-foreground">{step?.description}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="pt-4 border-t border-border">
        <p className="text-sm md:text-base text-muted-foreground mb-3">Recommended Tools:</p>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 md:gap-3">
          {recommendedTools?.map((tool, index) => (
            <button
              key={index}
              className="flex items-center justify-center gap-2 p-2 md:p-3 bg-muted hover:bg-muted-foreground/10 rounded-md transition-colors"
              aria-label={`Open ${tool?.name}`}
            >
              <Icon name={tool?.icon} size={16} />
              <span className="text-xs md:text-sm font-medium truncate">{tool?.name}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NextStepsGuide;